import { TFunction } from 'i18next'
import { CompleteInfoState } from 'src/core/models'

interface CompleteInfoSection {
  labelProps: { label: string }
  childLabel: string,
  formProps: {
    name:  keyof CompleteInfoState,
  }
}

export const getCompleteInfoFormSections = (t: TFunction): CompleteInfoSection[] => [

  { // Identity Document
    labelProps: { label: t('Auth.CompleteInfo.Identitydocument') },
    childLabel: t('Auth.CompleteInfo.IdentitydocumentLabel'),
    formProps: {
      name: 'identityDocument',
    }
  },

  { // Power Of Attorney
    labelProps: { label: t('Auth.CompleteInfo.PowerOfAttorney') },
    childLabel: t('Auth.CompleteInfo.PowerOfAttorneyLabel'),
    formProps: {
      name: 'powerOfAttorney',
    }
  },

  { // Company Documentation
    labelProps: { label: t('Auth.CompleteInfo.CompanyDocumentation') },
    childLabel: t('Auth.CompleteInfo.CompanyDocumentationLabel'),
    formProps: {
      name: 'companyDocumentation',
    }
  },
]
